<!-- Footer -->
<footer id="ftr" class="page-footer font-small stylish-color" style="bottom: 0 !important;">


  <!-- Footer Links -->
  <div class="container text-center text-md-left mt-5">
    <br />
    <!-- Grid row -->
    <div class="row mt-3">

      <!-- Grid column -->
      <div class="col-md-4 mx-auto mb-4">

        <!-- Content -->
        <h6 class="text-uppercase font-weight-bold">{{compName}}</h6>
        <hr class="danger-color mb-4 mt-0 d-inline-block mx-auto" style="width: 60px;">
        <p>{{address}}<br><br>
          <!-- <strong>Phone:</strong> +91 9607967675<br>
          <strong>Email:</strong> India.customercare@hitachiastemo.com<br>
          <strong>CIN No:</strong> U34200PN2011PTC140066<br> -->
        </p>

      </div>
      <!-- Grid column -->

     

      <!-- Grid column -->
      <div class="col-md-8 mx-auto mb-4">
  <!-- Links -->
  <h6 class="text-uppercase font-weight-bold">Useful links</h6>
  <hr class="danger-color mb-4 mt-0 d-inline-block mx-auto" style="width: 60px;">
    <div class="col-md-9 mx-auto mb-4">


  <div class="row">
    <div class="col-md-4 " *ngFor="let group of chunkedLinks" style="text-align: left;">
      <p *ngFor="let link of group">
        <a [href]="link.value" target="_blank">{{ link.key }}</a>
      </p>
    </div>
  </div>
</div>

  <!-- <p *ngFor="let link of usefulLinks | keyvalue">
    <a [href]="link.value" target="_blank">{{ link.key }}</a>
  </p> -->
</div>

      

    </div>
    <!-- Grid row -->

  </div>
  <!-- Footer Links -->

  <!-- Copyright -->
  <div class="footer-copyright text-center py-3">© {{Year}} Copyright:
    <a href="https://www.hitachiastemo.com/en/" target="_blank">{{compName}}</a>


  </div>
  <!-- Copyright -->

</footer>
<!-- Footer -->